var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9950_328973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8164 22C18.3393 22 22.8164 17.5228 22.8164 12C22.8164 6.47715 18.3393 2 12.8164 2C7.29356 2 2.81641 6.47715 2.81641 12C2.81641 17.5228 7.29356 22 12.8164 22Z",
    fill: "url(#paint0_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74805 19.0682C6.67501 19.9984 7.77662 20.7362 8.98961 21.2393C10.2026 21.7425 11.503 22.001 12.8162 22C15.4684 22 18.0119 20.9464 19.8873 19.0711C21.7627 17.1957 22.8162 14.6522 22.8162 12C22.8172 10.6868 22.5587 9.38637 22.0556 8.17339C21.5524 6.9604 20.8146 5.85878 19.8844 4.93182L5.74805 19.0682Z",
    fill: "url(#paint1_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27104 16.5455C8.27104 14.1344 9.22883 11.8221 10.9337 10.1172C12.6386 8.41233 14.9509 7.45454 17.3619 7.45454C18.6498 7.45493 19.9226 7.73242 21.0938 8.26818C20.3758 6.67333 19.213 5.31944 17.7449 4.36888C16.2767 3.41833 14.5655 2.91147 12.8165 2.90909C10.4054 2.90909 8.09313 3.86688 6.38825 5.57175C4.68338 7.27663 3.72559 9.58894 3.72559 12C3.72797 13.749 4.23483 15.4602 5.18538 16.9284C6.13593 18.3965 7.48982 19.5593 9.08468 20.2773C8.54892 19.1061 8.27142 17.8334 8.27104 16.5455Z",
    fill: "url(#paint2_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40732 11.0909C10.286 11.0909 10.9982 10.3786 10.9982 9.5C10.9982 8.62136 10.286 7.90909 9.40732 7.90909C8.52868 7.90909 7.81641 8.62136 7.81641 9.5C7.81641 10.3786 8.52868 11.0909 9.40732 11.0909Z",
    fill: "url(#paint3_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2257 11.0909C17.1043 11.0909 17.8166 10.3786 17.8166 9.5C17.8166 8.62136 17.1043 7.90909 16.2257 7.90909C15.347 7.90909 14.6348 8.62136 14.6348 9.5C14.6348 10.3786 15.347 11.0909 16.2257 11.0909Z",
    fill: "url(#paint4_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40736 10.6364C10.035 10.6364 10.5437 10.1276 10.5437 9.5C10.5437 8.8724 10.035 8.36363 9.40736 8.36363C8.77976 8.36363 8.271 8.8724 8.271 9.5C8.271 10.1276 8.77976 10.6364 9.40736 10.6364Z",
    fill: "url(#paint5_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2257 10.6364C16.8533 10.6364 17.3621 10.1276 17.3621 9.5C17.3621 8.8724 16.8533 8.36363 16.2257 8.36363C15.5981 8.36363 15.0894 8.8724 15.0894 9.5C15.0894 10.1276 15.5981 10.6364 16.2257 10.6364Z",
    fill: "url(#paint6_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8166 13.8182C16.412 13.8182 18.0211 15.9091 18.0893 16C18.1623 16.0947 18.216 16.2028 18.2472 16.3182C18.2784 16.4337 18.2865 16.5541 18.2711 16.6727C18.2544 16.7911 18.2144 16.9051 18.1536 17.008C18.0928 17.111 18.0122 17.2009 17.9166 17.2727C17.7567 17.3926 17.5618 17.4565 17.362 17.4545C17.222 17.4544 17.084 17.4219 16.9586 17.3596C16.8333 17.2973 16.724 17.2069 16.6393 17.0954C16.5938 17.0364 15.4847 15.6364 12.8166 15.6364C10.1484 15.6364 9.03928 17.0364 8.99382 17.0954C8.90914 17.2069 8.79985 17.2973 8.67449 17.3596C8.54913 17.4219 8.41108 17.4544 8.2711 17.4545C8.0744 17.4545 7.883 17.3907 7.72564 17.2727C7.62831 17.2018 7.54604 17.1122 7.48361 17.0092C7.42119 16.9062 7.37985 16.7918 7.36201 16.6727C7.32828 16.4345 7.39039 16.1925 7.53473 16C7.61201 15.9091 9.2211 13.8182 12.8166 13.8182Z",
    fill: "url(#paint7_linear_9950_328973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8164 14.2727C16.1846 14.2727 17.6664 16.1909 17.7255 16.2727C17.7978 16.3692 17.8289 16.4904 17.8118 16.6097C17.7948 16.7291 17.731 16.8368 17.6346 16.9091C17.5381 16.9814 17.4169 17.0125 17.2976 16.9954C17.1782 16.9784 17.0706 16.9146 16.9982 16.8182C16.9437 16.75 15.7073 15.1818 12.8164 15.1818C9.9255 15.1818 8.64823 16.8 8.63459 16.8182C8.56226 16.9146 8.45458 16.9784 8.33524 16.9954C8.21589 17.0125 8.09467 16.9814 7.99823 16.9091C7.90178 16.8368 7.83803 16.7291 7.82098 16.6097C7.80393 16.4904 7.83499 16.3692 7.90732 16.2727C7.96641 16.1909 9.44823 14.2727 12.8164 14.2727Z",
    fill: "url(#paint8_linear_9950_328973)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9950_328973",
    x1: 5.41186,
    y1: 3.65909,
    x2: 20.6937,
    y2: 20.8727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9950_328973",
    x1: 12.9071,
    y1: 12.0864,
    x2: 19.9071,
    y2: 18.9727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4901F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9950_328973",
    x1: 5.92104,
    y1: 4.99545,
    x2: 10.7529,
    y2: 9.90454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9950_328973",
    x1: 8.44822,
    y1: 8.32727,
    x2: 10.4164,
    y2: 10.7318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9950_328973",
    x1: 15.262,
    y1: 8.36818,
    x2: 17.2257,
    y2: 10.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9950_328973",
    x1: 8.721,
    y1: 8.66363,
    x2: 10.1301,
    y2: 10.3818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9950_328973",
    x1: 15.5348,
    y1: 8.69091,
    x2: 16.9439,
    y2: 10.3409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9950_328973",
    x1: 12.8166,
    y1: 17.3682,
    x2: 12.8166,
    y2: 14.6682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA4F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9950_328973",
    x1: 12.8164,
    y1: 16.8318,
    x2: 12.8164,
    y2: 14.1409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3035"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9950_328973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.81641 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/SAD.9c699a4db4f208bd70db971b3e15a997.svg";
export { ForwardRef as ReactComponent };